import { form } from '../../formState'
import { useTexts } from './useTexts'

export function Name() {
  const texts = useTexts()

  form.useAddFieldValidation('name', (field, _formApi) => {
    if (!field.value) {
      return texts.error
    }
  })

  return (
    <form.TextField
      label={texts.label}
      placeholder={texts.placeholder}
      validateOn="blur change"
      name="name"
      testId="name"
    />
  )
}
